<template>
  <div id="imt-comparison-landing-header">
    <h2 class="title text-center my-6">{{ landingTitle }}</h2>
    <HeaderMessage type="warning" class="mb-6">
      <strong>
        {{ $t('imt_landing.results_updated', { updatedAgo: '' }) }}
        <NuxtTime :datetime="timestamp" :locale="$lang" relative />
      </strong>
      <p class="lg:ml-3 lg:inline-block">
        {{ $t('imt_landing.for_live_results') }}
        <a class="link" href="#imt-search-modal">
          {{ $t('imt_landing.start_new_search') }}
        </a>
      </p>
    </HeaderMessage>
  </div>
</template>

<script lang="ts" setup>
import HeaderMessage from './header-message.vue'
import type { Corridor } from '@core/types/imt'

const props = defineProps<{
  corridorAmount: number
  providersCount: number
  timestamp: string | Date
}>()

const { $lang, $t } = useNuxtApp()

const corridor = inject('corridor') as Corridor

const formattedAmount = computed(() => {
  return formatMoney(props.corridorAmount, corridor.currencyFrom.iso, $lang, 0)
})

const landingTitle = computed(() => {
  const vars = {
    count: props.providersCount,
    amount: formattedAmount.value,
    fromCountry: corridor.countryFrom.labels.from,
    toCountry: corridor.countryTo.labels.to,
  }
  if (props.providersCount === 1) {
    return $t('imt_landing.title_one', vars)
  }
  return $t('imt_landing.title', vars)
})
</script>
